// removed by extract-text-webpack-plugin
module.exports = {"footer":"GWszn1OUtkGEqhBUrRyFH","footerBtn":"_1FvDemw_HBxOd315vhKcis","form":"_13Eki-GmL-iqLmf9_H2pHv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTokenUnwrapForm.scss
// module id = 1299
// module chunks = 0